module.exports = __webpack_public_path__ + "static/media/star.972df6d6.svg";